// extracted by mini-css-extract-plugin
export var active = "tags-module--active--ceca7";
export var deskContent = "tags-module--desk-content--0bd6e";
export var tags = "tags-module--tags--22071";